import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import axios from "axios";
import ProjectControl from "components/ProjectControl/ProjectControl";

import user1 from "../Assets/my-fronds/frond/user-1.svg";
import user2 from "../Assets/my-fronds/frond/user-2.svg";
import FrondCard from "components/FrondCard/FrondCard";
import { toast } from "react-toastify";
import empty from "../Assets/empty-screens/empty-my-fronds.svg";
import { Image } from "@nextui-org/react";
import { Link } from "react-router-dom";
import DataLoader from "pages/DataLoader/DataLoader";
import { SearchFrondContext } from "Context/SearchFrondContext";
import { ViewProjectsContext } from "Context/ViewProjectsContext";
import { PopUpContext } from "Context/PopUpContext";
import { SortContext } from "Context/SortContext";
import { FilterContext } from "Context/FilterContext";
import { CashedDataContext } from "Context/CashedDataContext";


export default function MyFrond() {
  const { searchValue, setSearchValue } = useContext(SearchFrondContext);
  const { frondSortTypes } = useContext(SortContext);
  const { frondFilterCategory, frondFilterTags } = useContext(FilterContext);
  const { myFrondsView, setPageType } = useContext(ViewProjectsContext);
  const { isArchiveProject, isDeleteProject } = useContext(PopUpContext);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [fronds, setFronds] = useState([]);

  let authToken = localStorage.getItem("token");

  const getFronds = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(
        "/frond",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setFronds(data?.response?.data);
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "An error occurred");
      toast(error?.response?.data?.message || "An error occurred", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getFronds();
  }, []);

  useLayoutEffect(() => {
    setSearchValue("");
    setPageType("my-fronds");
  }, []);

  useEffect(() => {
    if (isArchiveProject) {
      getFronds();
    }
  }, [isArchiveProject]);

  useEffect(() => {
    if (isDeleteProject) {
      getFronds();
    }
  }, [isDeleteProject]);

  // Sort And Filter

  const getNormalizedCategory = (category) => {
    const normalizedCategories = {
      Events: "Event",
      Ventures: "Venture",
      Others: "Other",
      Escapes: "Escape",
    };

    return normalizedCategories[category] || category.slice(0);
  };

  const normalizedFilterCategories = () => {
    if (frondFilterCategory?.length > 0) {
      return frondFilterCategory.map(getNormalizedCategory);
    }
    return [];
  };

  const getFilteredFronds = () => {
    let filteredFronds = [...fronds];
    const normalizedCategories = normalizedFilterCategories();

    if (frondSortTypes) {
      if (normalizedCategories?.length > 0) {
        filteredFronds = filteredFronds?.filter((item) => {
          const itemCategories = Array.isArray(item.frond.category)
            ? item.frond.category
            : [item.frond.category];

          return itemCategories.some((category) => {
            const normalizedCategory = getNormalizedCategory(category);
            return normalizedCategories.includes(normalizedCategory);
          });
        });
      }

      if (frondFilterTags?.length > 0) {
        filteredFronds = filteredFronds?.filter((item) => {
          const itemTags = Array.isArray(item.tags) ? item.tags : [];

          const itemTagNames = itemTags.map((tag) => tag.name.en);

          const filterTagNames = frondFilterTags.map(
            (filterTag) => filterTag.text
          );

          return itemTagNames.some((tagName) =>
            filterTagNames.includes(tagName)
          );
        });
      }

      if (frondSortTypes === "Name (A-Z)") {
        filteredFronds?.sort((a, b) => {
          const titleA = a.frond.title || "";
          const titleB = b.frond.title || "";
          return titleA.localeCompare(titleB, undefined, {
            sensitivity: "base",
          });
        });
      } else if (frondSortTypes === "Name (Z-A)") {
        filteredFronds?.sort((a, b) => {
          const titleA = a.frond.title || "";
          const titleB = b.frond.title || "";
          return titleB.localeCompare(titleA, undefined, {
            sensitivity: "base",
          });
        });
      } else if (frondSortTypes === "Start Date") {
        filteredFronds?.sort((a, b) => {
          const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const [day, month, year] = dateStr.split("-");
            return new Date(`${year}-${month}-${day}`);
          };

          const dateA = a.frond.start_date
            ? parseDate(a.frond.start_date)
            : null;
          const dateB = b.frond.start_date
            ? parseDate(b.frond.start_date)
            : null;

          if (dateA === null) return 1;
          if (dateB === null) return -1;

          return dateA - dateB;
        });
      } else if (frondSortTypes === "End Date") {
        filteredFronds?.sort((a, b) => {
          const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const [day, month, year] = dateStr.split("-");
            return new Date(`${year}-${month}-${day}`);
          };

          const dateA = a.frond.end_date ? parseDate(a.frond.end_date) : null;
          const dateB = b.frond.end_date ? parseDate(b.frond.end_date) : null;

          if (dateA === null) return 1;
          if (dateB === null) return -1;

          return dateA - dateB;
        });
      } else if (frondSortTypes === "Importance (High - Low)") {
        filteredFronds?.sort((a, b) => {
          const priorityMap = {
            High: 3,
            Medium: 2,
            Low: 1,
            null: 0,
          };

          const var1 = a.frond.priority ? priorityMap[a.frond.priority] : 0;
          const var2 = b.frond.priority ? priorityMap[b.frond.priority] : 0;

          return var2 - var1;
        });
      } else if (frondSortTypes === "Importance (Low - High)") {
        filteredFronds?.sort((a, b) => {
          const priorityMap = {
            High: 3,
            Medium: 2,
            Low: 1,
          };

          const var1 = a.frond.priority ? priorityMap[a.frond.priority] : 0;
          const var2 = b.frond.priority ? priorityMap[b.frond.priority] : 0;

          if (var1 === 0) return 1;
          if (var2 === 0) return -1;

          return var1 - var2;
        });
      } else if (frondSortTypes === "Last Updated") {
        filteredFronds?.sort((a, b) => {
          const dateA = a.frond.updated_at
            ? new Date(a.frond.updated_at)
            : null;
          const dateB = b.frond.updated_at
            ? new Date(b.frond.updated_at)
            : null;

          if (dateA === null) return 1;
          if (dateB === null) return -1;

          return dateB - dateA;
        });
      }
    }

    if (searchValue) {
      filteredFronds = filteredFronds?.filter((frond) =>
        (frond?.frond?.title || "")
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      );
    }

    return filteredFronds;
  };

  const filteredFronds = getFilteredFronds();

  const ITEMS_PER_PAGE = 12;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (currentPage > Math.ceil(filteredFronds.length / ITEMS_PER_PAGE)) {
      setCurrentPage(
        Math.max(Math.ceil(filteredFronds.length / ITEMS_PER_PAGE), 1)
      );
    }
  }, [filteredFronds, currentPage]);

  const totalPages = Math.ceil(filteredFronds.length / ITEMS_PER_PAGE);
  const currentItems = filteredFronds.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <section
      className={`my-fronds  bg-white rounded-4xl no-focus phone:p-5 px-2.5 py-[15px] ${
        filteredFronds?.length === 0 ? "min-h-[calc(100vh-192px)]" : ""
      }`}
    >
      {errorMessage ? (
        <div className="py-3 text-sm text-center text-white bg-cardColor rounded-15px">
          <span className="font-bold text-transparent bg-clip-text bg-mainGradiant">
            {errorMessage}
          </span>
        </div>
      ) : (
        <>
          <ProjectControl actions={["Archive", "Delete"]} page={"my-fronds"} />
          {isLoading ? (
            <div className="min-h-[400px] flex justify-center items-center">
              <DataLoader />
            </div>
          ) : filteredFronds?.length > 0 ? (
            <>
              <div
                className={`grid ${
                  myFrondsView === "grid"
                    ? "2xl:grid-cols-3 min-[1070px]:grid-cols-3 sm:grid-cols-2 custom-media"
                    : "grid-cols-1"
                }  phone:gap-5 gap-2.5`}
              >
                {currentItems.map((item) => (
                  <FrondCard
                    key={item?.frond?.id}
                    frondId={item?.frond?.id}
                    mainImg={item?.image}
                    title={item?.frond?.title}
                    category={item?.frond?.category}
                    startDate={item?.frond?.start_date}
                    endDate={item?.frond?.end_date}
                    location={item?.frond?.location}
                    isFronds={true}
                    userOne={
                      item?.members?.length > 0 && item?.members[0]?.img_url
                    }
                    userTwo={
                      item?.members?.length > 1 && item?.members[1]?.img_url
                    }
                    userOneName={
                      item?.members?.length > 0 && item?.members[0]?.name
                    }
                    userTwoName={
                      item?.members?.length > 1 && item?.members[1]?.name
                    }
                    restUsersName={
                      item?.members?.length > 2 &&
                      item?.members?.slice(2).map((member) => member?.name)
                    }
                    count={
                      item?.members?.length > 2 && item?.members?.length - 2
                    }
                  />
                ))}
              </div>

              {filteredFronds?.length > 12 && (
                <div className="flex justify-center items-center gap-2.5 mt-6">
                  <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="smallPhone:px-4 px-2.5 py-2 smallPhone:text-base text-xs bg-mainGradiant rounded-xl text-white font-medium disabled:opacity-50"
                  >
                    Prev
                  </button>
                  <span className="text-sm font-semibold smallPhone:text-lg text-textColor">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    className="smallPhone:px-4 px-2.5 py-2 smallPhone:text-base text-xs bg-mainGradiant rounded-xl text-white font-medium disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="flex flex-col justify-center items-center translate-y-[53.2px] gap-6 min-h-[calc(100%-43.2px)]">
              <Image src={empty} alt="No fronds" />
              <p className="text-cardGrayColor leading-[20.7px] text-lg font-bold text-center">
                You currently don’t have any projects
              </p>
              <Link
                to={"/create-frond"}
                className="text-white font-bold text-lg leading-[20.7px] w-[174px] h-[45px] rounded-4xl py-3 px-5 bg-[#424C9B] shadow-whatsappShadow"
              >
                Create a frond
              </Link>
            </div>
          )}
        </>
      )}
   
    </section>
    
  );
}
